import { tv } from 'tailwind-variants';

export const styles = {
  root: 'flex-1 bg-neutral20',
  wrapper: 'flex-1 ',
  keyboardView: tv({
    base: 'flex-1 border-t border-[transparent]',
    variants: {
      scrolled: {
        true: 'border-neutral20',
      },
    },
  }),
  scrollViewContainer:
    'gap-page mx-auto w-full max-w-[80rem] p-lg pt-0 md:p-xl md:pt-0 lg:p-2xl lg:pt-2xl',
  content: 'flex-1 flex-row flex-nowrap',
  step: 'w-full',
} as const;
